import styled from 'styled-components';

export const Container = styled.div`
    height: 100vh;
    padding-top: 70px;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    align-self: center !important;
    align-items: center !important;
    /* justify-content: center !important; */

    .div-input {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-disabled {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-focado {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-bottom: 24px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-error {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-bottom: 8px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .logocompletovermelho {
        width: 240px;
        height: 72px;
        margin-bottom: 104px;
        object-fit: contain;
    
        @media(max-width: 360px) {
            margin-bottom: 32px;
            width: 214px;
            height: 64px;
        }
    }

    .div-bem-vindo {
        margin-bottom: 48px;

        .sejabemvindo {
            overflow: hidden;
            font-family: Montserrat;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #1c0506;
            text-align: center;
            cursor: default;

            @media(max-width: 590px) {
                display: block;
                align-self: center;
            }
        }

        .paineldorestaurante {
            overflow: hidden;
            font-family: Montserrat;
            font-size: 24px;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #1c0506;
            text-align: center;
            cursor: default;
            font-weight: 600;
            text-align: center;
            padding-left: 8px;

            @media(max-width: 590px) {
                padding-left: 0px;
                display: block;
                margin-top: 16px;
            }
        }
    }

    .div-botao {
        position: relative;
        width: 95%;
        height: 72px;
        max-width: 550px;
        overflow: hidden;
        box-sizing: border-box;
        margin-top: 48px;
        margin-bottom: 40px;

            .botaologin {
            width: 100%;
            height: 100%;
            background-color: lightgrey;
            color: #1c0506;
            object-fit: contain;
            text-align: center;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            border-radius: 50px;
            border: none;
            outline: none;
            cursor: pointer;
        }

            .botaologin-active {
            width: 100%;
            height: 100%;
            background-color: #c32027;
            color: #fff;
            object-fit: contain;
            text-align: center;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            border-radius: 50px;
            border: none;
            outline: none;
            cursor: pointer;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
        }

        .spinner {
            position: absolute;
            top: 28px;
            right: 48%;

            @media(max-width: 360px) {
                top: 24px;
                right: 47%;
            }
        }

        @media(max-width: 360px) {
            margin-bottom: 32px;
            margin-top: 32px;
            height: 64px;
        }
    }

    .div-selects {
        display: flex;
        flex-direction: column;
    }

    select {
        margin-bottom: 10px;
        font-family: Montserrat;
        font-size: 14px;
        color: #2a0709;
        font-weight: 500;
        height: 50px;
        outline: none;
        cursor: pointer
    }

    @media(max-width: 590px) {
        margin-top: 70px;
    }

    @media(max-width: 425px) {
        margin-top: 50px;
    }

    @media(max-width: 360px) {
        margin-top: 30px;
    }   
​

.div-bem-vindo {
    margin-bottom: 48px;

    .sejabemvindo {
        overflow: hidden;
        font-family: Montserrat;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #1c0506;
        text-align: center;
        cursor: default;

        @media(max-width: 590px) {
            display: block;
            align-self: center;
        }
    }

    .paineldorestaurante {
        overflow: hidden;
        font-family: Montserrat;
        font-size: 24px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #1c0506;
        text-align: center;
        cursor: default;
        font-weight: 600;
        text-align: center;
        padding-left: 8px;

        @media(max-width: 590px) {
            padding-left: 0px;
            display: block;
            margin-top: 16px;
        }
    }
}

    .close {
        cursor: pointer;
        padding: 0;
        background: none;
        position: absolute;
        top: 24px;
        right: 24px;
        width: 32px;
        height: 32px;
        border: none;
        outline: none;
    }

    h1 {
        font-size: 28px;
        color: #000000;
        font-family: Montserrat;
        font-weight: 700;
        outline: none;
    }
    
    h2 {
        font-size: 20px;
        color: #000000;
        font-family: Montserrat;
        font-weight: 600;
        outline: none;
    }
​
    label {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 8px;
    color: #000
    }

    .div-cadastre {
        align-items: center;
        align-self:  center;
        justify-content: center;
        flex-direction: row !important;

        .Ainda-no-parceiro-da-appedidos {
            overflow: hidden;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #1c0506;
            text-align: center;
            cursor: default;

            @media(max-width: 590px) {
                display: block;
            }
        }

        .Cadastre-seu-restaurante {
            overflow: hidden;
            outline: none;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #c32027;
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            padding-left: 8px;

            :hover {
                opacity: 0.8;
            }

            @media(max-width: 590px) {
                margin-top: 16px;
                display: block;
                padding-left: 0;
            }
        }
    }

`